import { render, staticRenderFns } from "./dialog-confirm.mpx?vue&type=template&id=75ce846e&isComponent&outputPath=components%2Fdialog-confirm863ba266%2Findex"
import script from "./dialog-confirm.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdialog-confirm863ba266%2Findex"
export * from "./dialog-confirm.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fdialog-confirm863ba266%2Findex"
import style0 from "./dialog-confirm.mpx?vue&type=style&index=0&id=75ce846e&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_863ba266%22%7D&isComponent&outputPath=components%2Fdialog-confirm863ba266%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports